<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos de la Imagen</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveImage" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="name" class="form__label form__label--required">Nombre de la Imágen (Uso interno)</label>
                <input type="text" class="form__input" name="name" id="name" placeholder="Nombre de la imagen" v-model="image.name" v-validate="validation.name">
                <span v-show="errors.has('name')" class="form__alert">{{ errors.first('name') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="title_es" class="form__label">Título de la Imagen</label>
                <input type="text" class="form__input" name="title_es" id="title_es" placeholder="Título de la Imagen" v-model="image.title_es" v-validate="validation.title_es">
                <span v-show="errors.has('title_es')" class="form__alert">{{ errors.first('title_es') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="subtitle_es" class="form__label">Sub Título de la Imagen</label>
                <input type="text" class="form__input" name="subtitle_es" id="subtitle_es" placeholder="Sub Título de la Imagen" v-model="image.subtitle_es" v-validate="validation.subtitle_es">
                <span v-show="errors.has('subtitle_es')" class="form__alert">{{ errors.first('subtitle_es') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="link" class="form__label">Enlace de la imagen</label>
                <input type="text" class="form__input" name="link" id="link" placeholder="Enlace de la imagen" v-model="image.link" v-validate="validation.link">
                <span v-show="errors.has('link')" class="form__alert">{{ errors.first('link') }}</span>
              </div>

              <div class="form__container form__container--wide">
                <label for="last_name" class="form__label">Cuerpo de texto de la Imagen</label>
                <textarea class="form__input" name="description_es" id="description_es" placeholder="Cuerpo de texto de la Imagen" v-model="image.description_es" v-validate="validation.description_es"></textarea>
                <span v-show="errors.has('description_es')" class="form__alert">{{ errors.first('description_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="image" class="form__label">Imagen</label>
                <img v-if="thumb" :src="thumb" alt="" class="form__thumb">
                <button class="btn btn--regular btn__default" @click.prevent="addImage">Agregar Imagen</button>
                <button v-if="thumb" @click.prevent="removeImage" class="btn btn__transparent btn--regular">Quitar imagen</button>
                <span v-show="errors.has('image')" class="form__alert">{{ errors.first('image') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="position" class="form__label">Posición</label>
                <input type="text" class="form__input" name="position" id="position" placeholder="Posición" v-model="image.position" v-validate="validation.position">
                <span v-show="errors.has('position')" class="form__alert">{{ errors.first('position') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.estatus_id" v-model="image.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="gallery_id" class="form__label form__label--required">Grupo de Galería</label>
                <div class="form__select-container">
                  <select name="gallery_id" id="gallery_id" class="form__select" v-validate="validation.gallery_id" v-model="image.gallery_id">
                    <option :value="null">Seleccionar Galería</option>
                    <option v-for="(gallery, index) in galleries" :key="index" :value="gallery.id" v-text="gallery.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('gallery_id')" class="form__alert">{{ errors.first('gallery_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryList', params: {page: 1}}">Lista de Galerías</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryImageList', params: {gallery_id: $route.params.gallery_id ,page: 1}}">Lista de Imágenes</router-link>
        <router-link v-if="$route.name === 'galleryImageEdit'" class="btn btn--small btn__default" :to="{name: 'galleryImageNew'}">Nueva Imagen</router-link>
      </aside>
    </div>
    <popup-viewer name="image" @close="mediaManager = false" v-if="mediaManager"></popup-viewer>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, ImageFields, statusList, texts} from './image.mocks'
import popupViewer from '@/components/media/popup'
import {config} from '@/assets/js/config/base'
export default {
  mixins: [httpService],
  components: {popupViewer},
  data: function () {
    return {
      validation: validation,
      image: null,
      galleries: [],
      statusList: statusList,
      mediaManager: false,
      thumb: config.local.noImage
    }
  },
  created: function () {
    this.start()
  },
  mounted: function () {
    this.$on('image', image => {
      this.image.image = JSON.stringify(image)
      this.thumb = image.images.thumb[0]
      this.mediaManager = false
    })
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getGalleries()
      if (this.imageId) {
        this.getImage()
      }
      if (!this.imageId) {
        this.thumb = config.local.noImage
        this.image = new ImageFields()
      }
    },
    addImage: function () {
      this.mediaManager = true
    },
    removeImage: function () {
      this.thumb = config.local.noImage
      this.image.image = null
    },
    getImage: function () {
      let httpRequest = {
        params: '',
        module: 'gallery_images'
      }
      this.getById(this.imageId, httpRequest)
        .then(
          image => {
            this.image = image.data
            let thumb = JSON.parse(image.data.image)
            this.thumb = thumb.images.thumb[0]
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'galleryImageNew'})
          }
        )
    },
    getGalleries: function () {
      let httpRequest = {
        params: '',
        module: 'galleries'
      }
      this.get(httpRequest)
        .then(
          galleries => {
            this.galleries = galleries.data
          }
        )
    },
    saveImage: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'gallery_images',
                element: this.image
              }
              let request
              if (this.$route.name === 'galleryImageEdit') {
                request = this.put(this.imageId, httpRequest)
              } else if (this.$route.name === 'galleryImageNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'galleryImageNew') {
                    this.$router.push({name: 'galleryImageEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    imageId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.image
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/galleries/image.edit.vue